export const userTypes = {
  installer_admin: 'Installer管理者ユーザ',
  developer_tester: '開発・テスト担当ユーザ',
  licensed_user: '正式ライセンスユーザ',
  poc_trial: 'POC・トライアルユーザ',
};
export const contractTypes = {
  licensed: '正式ライセンス',
  poc_trial: 'POC・トライアル',
  internal: '社内開発・テスト',
};
export const statuses = {
  draft: '未公開',
  testing: 'テスト公開',
  released: '正式公開',
  stopped: '配信停止',
};
export function dateInput(value, end = false) {
  if (!value) return '';
  const parsed = new Date(
    /[zZ]$/.test(value) ? value : value.replace(' ', 'T') + 'Z'
  );
  return new Date(parsed.getTime() + 9 * 3600000 - (end ? 86400000 : 0))
    .toISOString()
    .slice(0, 10);
}
export function dateUtc(value, end = false) {
  return value
    ? new Date(
        new Date(value + 'T00:00:00+09:00').getTime() + (end ? 86400000 : 0)
      ).toISOString()
    : null;
}
export function prettyDate(value, end = false) {
  return value ? dateInput(value, end) : '制限なし';
}
export function prettyTime(value) {
  if (!value) return '';
  return new Date(
    /[zZ]$/.test(value) ? value : value.replace(' ', 'T') + 'Z'
  ).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
}
export const freshInstaller = () => ({
  docker_version: '',
  release_date: '',
  docker_info: '',
  configuration: 'SA',
  install_kind: 'IN',
  change_type: '',
  from_release: '',
  target_os: 'windows',
  target_arch: 'x64',
  module_ids: '',
  release_notes: '',
});
